import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { NotificationCard } from 'framework/ui/layout';
import { InterruptionNotificationResponse } from '../types';
import { useNavigate } from 'react-router-dom';
import { getInterruptionNotificationTitle } from '../shared/helpers/notificationHelpers';
import { SYBERRY_TODAY_PATH } from 'domain/people/syberryToday/SyberryTodayRouter';

const InterruptionNotification = ({ response }: { response: InterruptionNotificationResponse }) => {
  const count = response?.count || 0;

  const navigate = useNavigate();

  const onClick = () => {
    navigate(SYBERRY_TODAY_PATH);
  };

  return (
    <NotificationCard
      onClick={() => onClick()}
      actionLabel="Review"
      title={getInterruptionNotificationTitle(count)}
      description="Review the interruptions that require your attention."
      accentColor="error.main"
      accentSoftColor="background.error"
      icon={<NotificationsActiveOutlinedIcon sx={{ fontSize: 18 }} />}
    />
  );
};

export default InterruptionNotification;
